var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('figure',{class:`${_vm.baseClass}`},[_c('img',{class:[
      `${_vm.baseClass}__image`,
      {
        [`${_vm.baseClass}__image--small`]: _vm.smallImage,
      },
    ],attrs:{"src":_vm.imageSource,"alt":_vm.imageAlt}}),_c('figcaption',{class:`${_vm.baseClass}__message`},[(_vm.title)?_c('EpbText',{class:`${_vm.baseClass}__title`,attrs:{"tag":"h4"}},[_vm._v(_vm._s(_vm.title))]):_vm._e(),_c('EpbText',{attrs:{"tag":"p"}},[_vm._t("default")],2)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }